import type { NavigationGuard } from 'vue-router';
import { TENANT } from '@/utils/helpers';

/**
 * This guard redirects the user to the universal login page when the path is '/' and when no tenant is specified
 * Eg. http://localhost:8080 will be redirected to http://localhost:8080/login
 */
export const handleUniversalLoginRedirection: NavigationGuard = async (to, from, next) => {
  if (!TENANT) {
    return next({ name: 'universal-login' });
  }

  return next();
};
